import { VdsCard } from '@volt/volt-extended-components-react';
import styles from './InsightsCard.module.scss';
import { Fragment, ReactElement } from 'react';

interface InsightsCardProps {
  sections: ReactElement[];
  cols?: number;
}

export const InsightsCard = ({ sections, cols = 3 }: InsightsCardProps) => {
  return (
    <VdsCard padding="spacing-05">
      <article className={`${styles.container} ${styles[`container--col-${cols}`]}`}>
        {sections.map((section: ReactElement, i: number) => {
          return (
            <Fragment key={i}>
              {i > 0 && <div className={styles.divider} />}
              <section className={`${styles.section} ${cols === 3 && styles['section--pad']}`}>
                {section}
              </section>
            </Fragment>
          );
        })}
      </article>
    </VdsCard>
  );
};

export default InsightsCard;
